"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.League = void 0;
/**
 * Represents sports leagues supported by PFFKit.
 */
var League;
(function (League) {
    /** The National Football League. */
    League["NFL"] = "nfl";
    /** No associated league value. */
    League["None"] = "";
})(League || (exports.League = League = {}));
//# sourceMappingURL=league.js.map